import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import arrowUp from '../imgs/arrow-up-icon.svg';
import arrowDown from '../imgs/arrow-down-icon.svg';
import { useStoreSelector } from '../helpers/hooks';

function checkLongWord(string) {
  if (!string) return false;

  const wordsArr = string.split(' ');
  return !!wordsArr.find((word) => word.length > 35);
}

export default function ConnectedPaymentCard() {
  const {
    shopOrderId,
    description,
    amount,
    currency: { name: currencyName },
  } = useStoreSelector((selector) => selector.getPayment());

  const { name: shopName } = useStoreSelector((selector) => selector.getShop());

  return (
    <PaymentCard
      shopOrderId={shopOrderId}
      description={description}
      amount={amount}
      currency={currencyName}
      shop={shopName}
    />
  );
}

export function PaymentCard({
  shopOrderId,
  description,
  amount,
  currency,
  shop = null,
  inlineInvoiceId = false,
}) {
  const [isDescriptionVisible, setIsDescriptionVisible] = useState(false);
  function toggleDescription() {
    setIsDescriptionVisible(!isDescriptionVisible);
  }

  const refDesc = useRef();
  const { t } = useTranslation();

  return (
    <section className="block invoice">
      {!inlineInvoiceId && (
        <h3>
          {t('Payment.Invoice')} {t('numberSign')}
          {shopOrderId}
        </h3>
      )}

      <div className="invoice__description">
        <div className="block__text">
          {inlineInvoiceId && (
            <div className="block__inline">
              <div>{t('Payment.Invoice')}:</div>
              <div>{shopOrderId}</div>
            </div>
          )}

          {shop != null && (
            <div className="block__inline">
              <div>{t('Payment.ShopName')}:</div>
              <div>{shop}</div>
            </div>
          )}

          {description ? (
            <div
              className={classnames('block__inline', {
                'mob-column': isDescriptionVisible,
              })}
            >
              <div>{t('Payment.Desc')}:</div>
              <div
                className={classnames(
                  'invoice__text-description',
                  { 'text--short': !isDescriptionVisible },
                  { 'text--break': checkLongWord(description) }
                )}
                ref={refDesc}
                style={
                  isDescriptionVisible
                    ? { maxHeight: refDesc.current.scrollHeight }
                    : {}
                }
              >
                {description}
              </div>
            </div>
          ) : null}
        </div>
        <div className="invoice__total">
          <span>
            {amount} {currency}
          </span>
          <p>{t('Payment.Amount')}</p>
        </div>
      </div>
      {typeof description == 'string' && description.length > 75 ? (
        <div
          className="show-more link text--center"
          onClick={toggleDescription}
        >
          {isDescriptionVisible ? (
            <>
              {t('Payment.HideDesc')} <img src={arrowUp} alt="" />
            </>
          ) : (
            <>
              {t('Payment.ShowDesc')} <img src={arrowDown} alt="" />
            </>
          )}
        </div>
      ) : null}
    </section>
  );
}
